import Incident from '@/models/Incident'
// import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    }
  },
  mutations: {
    setIncidentList(state, incidents) {
      each(incidents, incident => {
        const exist = find(state.list, { id: incident.id })

        if (!exist) {
          state.list.push(new Incident(incident))
        }
      })
    },

    setIncidentListMeta(state, meta) {
      state.listMeta = meta
    },

    clearIncidentList(state) {
      state.list = []
    }
  },
  actions: {
    async getIncidents({ commit }, params) {
      const query = Incident.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setIncidentList', res.data)
      commit('setIncidentListMeta', res.meta)
    }
  }
}
